import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import DataTableComp from '../../common/data-table/DataTableComp'
import useAccess from '../../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../../utils/constants/roles'
import rowDelete from '../../common/data-table/column-types/rowDelete'
import {
  bodyParseDate,
  bodyStatusTag,
} from '../../common/data-table/column-types/ColumnTypes'
import editTextRowColumn from '../../common/data-table/editors/editTextRowColumn'
import {
  formatFuelQuantity,
  formatCurrency,
} from '../../../utils/helpers/common'
import AppCheckbox from '../../../component/form/AppCheckbox'

const MadePurchaseTable = ({
  loading = false,
  value,
  sortOptions,
  pagerOptions,
  viewOwnStation,
  handleDelete,
  handleEdit,
}) => {
  const { formatMessage: msg } = useIntl()
  const { canDelete, canEdit } = useAccess()

  const onCellEditComplete = async (newData) => {
    const body = {}
    if (newData?.field) {
      if (
        newData.field === 'deliveryNote' ||
        newData.field === 'bill' ||
        newData.field === 'remarks'
      ) {
        body[newData.field] = newData.newValue
      }
    }
    await handleEdit({ _id: newData?.rowData?._id, body })
  }

  return (
    <DataTableComp
      loading={loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        value,
        size: 'small',
        editMode: 'cell',
        dataKey: '_id',
        onCellEditComplete: handleEdit && onCellEditComplete,
        ...sortOptions,
      }}
      columns={[
        <Column
          key={Math.random()}
          header={msg({ id: 'date.purchase' })}
          field="purchaseDate"
          sortable
          body={(rowData) => bodyParseDate({ date: rowData?.purchaseDate })}
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'date.download' })}
          field="downloadDate"
          sortable
          body={(rowData) => bodyParseDate({ date: rowData?.downloadDate })}
        />,
        viewOwnStation && (
          <Column
            key={Math.random()}
            header={msg({ id: 'gas.station' })}
            sortable
            field="centerName"
          />
        ),
        <Column
          key={Math.random()}
          header={msg({ id: 'supplier' })}
          field="supplier.name"
          sortable
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'quantity.GOA' })}
          field="quantity.GOA"
          style={{ textAlign: 'right' }}
          body={(rowData) => formatFuelQuantity(rowData?.quantity?.GOA, true)}
          sortable
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'price.GOA' })}
          field="prices.GOA.price"
          style={{ textAlign: 'right' }}
          sortable
          body={(rowData) =>
            formatCurrency(rowData?.prices?.GOA?.price, {}, true)
          }
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'quantity.G95' })}
          field="quantity.G95"
          style={{ textAlign: 'right' }}
          body={(rowData) => formatFuelQuantity(rowData?.quantity?.G95, true)}
          sortable
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'price.G95' })}
          field="prices.G95.price"
          style={{ textAlign: 'right' }}
          sortable
          body={(rowData) =>
            formatCurrency(rowData?.prices?.G95?.price, {}, true)
          }
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'quantity.GOAPLUS' })}
          field="quantity.GOAPLUS"
          style={{ textAlign: 'right' }}
          body={(rowData) =>
            formatFuelQuantity(rowData?.quantity?.GOAPLUS, true)
          }
          sortable
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'transporter.price' })}
          field="transporter.price"
          style={{ textAlign: 'right' }}
          sortable
          body={(rowData) =>
            formatCurrency(rowData?.transporter?.price, {}, true)
          }
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'transporter.email' })}
          field="transporter.email"
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'delivery.note' })}
          field="deliveryNote"
          sortable
          {...editTextRowColumn}
          onCellEditComplete={(rowData) => onCellEditComplete(rowData)}
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'bill' })}
          field="bill"
          sortable
          body={(rowData) => {
            return <AppCheckbox disabled checked={rowData.bill} />
          }}
          {...editTextRowColumn}
          onCellEditComplete={(rowData) => onCellEditComplete(rowData)}
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'remarks' })}
          field="remarks"
          {...editTextRowColumn}
          onCellEditComplete={(rowData) => onCellEditComplete(rowData)}
        />,
        <Column
          key={Math.random()}
          header={msg({ id: 'status' })}
          field="cancelled"
          body={(rowData) => bodyStatusTag(rowData?.cancelled)}
          sortable
        />,
        canDelete(MODULES.PURCHASE_FUEL, GROUPS.MADE) && handleDelete && (
          <Column key={Math.random()} {...rowDelete({ handleDelete })} />
        ),
        // canEdit(MODULES.PURCHASE_FUEL, GROUPS.MADE)
        // && handleEdit && (<Column key={Math.random()} {...rowEditor()} />)
      ]}
    />
  )
}

export default MadePurchaseTable
